export function replaceSharpS(title) {
  if (typeof title === 'string') {
    return title.match(/ß/i) ? title.replace(/ß/gi, 'ẞ') : title;
  }
  return title;
}
